import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Stack } from '@mui/material'
import { useGetMaterialTypeQuery } from 'services/materialTypes'
import { MATERIAL_TYPE_RULES } from 'utils/constants'
import MaterialProperties from './material-properties/MaterialProperties'
import { useMaterialHeader } from './useMaterialHeader'

const MaterialPropertiesContainer = () => {
  const { materialId: materialTypeId } = useParams()
  const [values, setValues] = useState({
    commodityName: '',
    materialCode: '',
    materialName: '',
    isriCode: '',
    accountingCode: '',
    accountingExpenseCode: '',
    materialNotes: '',
    tareWeightRequired: '',
    paymentHoldTime: '',
    paymentMethods: [],
  })

  const { data: materialTypeData } = useGetMaterialTypeQuery({ materialTypeId })
  useMaterialHeader(materialTypeData)

  useEffect(() => {
    if (materialTypeData) {
      setValues({
        materialName: materialTypeData.commonName,
        commodityName: materialTypeData.commodityName,
        materialCode: materialTypeData.code,
        isriCode: materialTypeData?.isriCode,
        accountingCode: materialTypeData?.accountingCode,
        accountingExpenseCode: materialTypeData?.accountingExpenseCode,
        materialNotes: materialTypeData?.notes,
        tareWeightRequired: materialTypeData?.tareWeightRequired ? 'Yes' : 'No',
        paymentHoldTime: materialTypeData?.rules
          .filter(rule => rule.type === MATERIAL_TYPE_RULES.PAYMENT_HOLD)
          .map(rule => rule.parameters?.days + ' days'),
        paymentMethods: materialTypeData?.rules
          .filter(rule => rule.type === MATERIAL_TYPE_RULES.PAYMENT_METHODS)
          .map(rule => rule.parameters?.paymentMethods.join(', ').toUpperCase()),
      })
    }
  }, [materialTypeData])

  return (
    <Stack>
      <MaterialProperties defaultValues={values} />
    </Stack>
  )
}

export default MaterialPropertiesContainer
